// Main entry — the ProgramHeader View. It owns no fetch; the program +
// draft-name value/setter + regions + funding accounts come in as props
// from ProgramDetail. Sim wrappers live under ./sim and are never imported
// here.
export { ProgramHeader } from "./ProgramHeader";
export type { ProgramHeaderProps } from "./ProgramHeader";
